var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2M5 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2m13-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 10c-.817 0-1.557.33-2.099.861l-7.935-3.526C7.979 12.224 8 12.114 8 12c0-.114-.021-.224-.034-.335l7.935-3.526A2.991 2.991 0 0 0 18 9c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .114.021.224.034.335L7.099 9.861A2.991 2.991 0 0 0 5 9c-1.654 0-3 1.346-3 3s1.346 3 3 3c.817 0 1.557-.33 2.099-.861l7.935 3.526c-.013.111-.034.221-.034.335 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};
export default SvgIconShare;